export const icon = 'calendar-star'

export const humanName = {
  singular: 'Programação',
  plural: 'Programação'
}

type Breadcrumb = { href: string; name: string }

type GetConfigProps = {
  digitalProductId: string
}

/**
 * Configuração de rota e de API do módulo.
 *
 * Regras de domínio (status temporal, agrupamento, tipo de sessão, filtros)
 * vivem em `model/` — não aqui. Antes da refatoração este arquivo acumulava as
 * três responsabilidades, e era o que mantinha o mapa de tipos de sessão fora
 * de qualquer verificação contra o contrato da api.
 */
export const getConfig = ({ digitalProductId }: GetConfigProps) => {
  const basePath = '/programacao'
  const apiBasePath = `/user/digital_products/${digitalProductId}/programmings`

  const getBreadcrumbs = (breadcrumbs: Breadcrumb[] = []): Breadcrumb[] => [
    { href: basePath, name: humanName.plural },
    ...breadcrumbs
  ]

  return {
    basePath,
    apiBasePath,
    icon,
    humanName,
    getBreadcrumbs,
    // Dívida conhecida: carrega o evento inteiro numa requisição. Sair disso
    // exige trocar o HOC `withResourceRecords` por TanStack Query — fora do
    // escopo desta feature (ver design.md §11).
    pagination: { perPage: 999 },
    sort: {
      field: 'start_at',
      order: 'asc'
    }
  }
}
